"use strict";
/**
 * Little AbortController proxy module so we can swap out the implementation easily later.
 */

exports.AbortController = globalThis.AbortController;
exports.AbortSignal = globalThis.AbortSignal;

exports.createAbortError = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Aborted';
  return new DOMException(message, 'AbortError');
};